// import React, { useState } from "react";

// const RaiseTicket = () => {
//     const [ticketData, setTicketData] = useState({
//         name: "",
//         email: "",
//         phone: "",
//         issueType: "",
//         priority: "Medium",
//         subject: "",
//         description: "",
//         attachments: []
//     });

//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [showTable, setShowTable] = useState(false);
//     const [tickets, setTickets] = useState([]);

//     const styles = {
//         container: {
//             padding: "20px",
//             maxWidth: "1200px",
//             margin: "0 auto",
//             marginBottom: "00px",
//             paddingTop: window.innerWidth < 500 ? "0px" : " ",
//             paddingLeft: window.innerWidth < 500 ? "0px" : " ",
//             paddingRight: window.innerWidth < 500 ? "25px" : " ",
//         },
//         title: {
//             color: "#6a0dad",
//             marginBottom: "10px",
//             textAlign: "center",
//             fontSize: "28px",
//             fontWeight: "bold"
//         },
//         subtitle: {
//             color: "#666",
//             textAlign: "center",
//             marginBottom: "30px",
//             fontSize: "16px"
//         },
//         form: {
//             background: "#fff",
//             borderRadius: "10px",
//             padding: "30px",
//             boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
//             marginBottom: "40px"
//         },
//         formRow: {
//             display: "grid",
//             gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
//             gap: "20px",
//             marginBottom: "20px"
//         },
//         formGroup: {
//             marginBottom: "20px"
//         },
//         label: {
//             display: "block",
//             marginBottom: "8px",
//             fontWeight: "bold",
//             color: "#333"
//         },
//         input: {
//             width: "100%",
//             padding: "12px",
//             border: "1px solid #ddd",
//             borderRadius: "5px",
//             fontSize: "14px"
//         },
//         select: {
//             width: "100%",
//             padding: "12px",
//             border: "1px solid #ddd",
//             borderRadius: "5px",
//             fontSize: "14px"
//         },
//         textarea: {
//             width: "100%",
//             padding: "12px",
//             border: "1px solid #ddd",
//             borderRadius: "5px",
//             fontSize: "14px",
//             resize: "vertical"
//         },
//         fileUpload: {
//             marginTop: "10px"
//         },
//         fileInput: {
//             display: "none"
//         },
//         fileLabel: {
//             display: "inline-block",
//             padding: "10px 20px",
//             background: "#6a0dad",
//             color: "white",
//             borderRadius: "5px",
//             cursor: "pointer",
//             transition: "background 0.3s"
//         },
//         fileHint: {
//             fontSize: "12px",
//             color: "#666",
//             marginTop: "5px"
//         },
//         attachmentsList: {
//             marginTop: "15px"
//         },
//         attachmentItem: {
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             padding: "8px",
//             background: "#f8f9fa",
//             borderRadius: "5px",
//             marginBottom: "5px"
//         },
//         removeButton: {
//             background: "#dc3545",
//             color: "white",
//             border: "none",
//             borderRadius: "50%",
//             width: "24px",
//             height: "24px",
//             cursor: "pointer"
//         },
//         formFooter: {
//             marginTop: "30px",
//             textAlign: "center"
//         },
//         submitBtn: {
//             background: "#6a0dad",
//             color: "white",
//             border: "none",
//             padding: "12px 40px",
//             borderRadius: "5px",
//             fontSize: "16px",
//             cursor: "pointer",
//             transition: "background 0.3s"
//         },
//         submitBtnDisabled: {
//             background: "#ccc",
//             cursor: "not-allowed"
//         },
//         note: {
//             fontSize: "12px",
//             color: "#666",
//             marginTop: "10px"
//         },
//         tableContainer: {
//             background: "white",
//             borderRadius: "10px",
//             padding: "20px",
//             boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
//             marginTop: "40px",
//             animation: "fadeIn 0.5s ease-in"
//         },
//         tableHeader: {
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             marginBottom: "20px"
//         },
//         tableTitle: {
//             color: "#6a0dad",
//             margin: 0,
//             fontSize: "22px",
//             fontWeight: "bold"
//         },
//         table: {
//             width: "100%",
//             borderCollapse: "collapse"
//         },
//         th: {
//             padding: "15px",
//             textAlign: "left",
//             fontWeight: "bold",
//             color: "#333",
//             borderBottom: "2px solid #dee2e6",
//             background: "#f8f9fa"
//         },
//         td: {
//             padding: "15px",
//             borderBottom: "1px solid #dee2e6",
//             verticalAlign: "top"
//         },
//         statusBadge: {
//             padding: "5px 12px",
//             borderRadius: "20px",
//             fontSize: "12px",
//             fontWeight: "bold",
//             display: "inline-block"
//         },
//         priorityBadge: {
//             padding: "4px 10px",
//             borderRadius: "4px",
//             fontSize: "12px",
//             fontWeight: "bold",
//             display: "inline-block"
//         },
//         actionButton: {
//             padding: "6px 12px",
//             background: "#6a0dad",
//             color: "white",
//             border: "none",
//             borderRadius: "4px",
//             cursor: "pointer",
//             fontSize: "12px",
//             marginRight: "5px"
//         },
//         noTickets: {
//             textAlign: "center",
//             padding: "40px",
//             color: "#666",
//             fontSize: "16px",
//             background: "#f8f9fa",
//             borderRadius: "10px"
//         },
//         hideTableBtn: {
//             background: "#6a0dad",
//             color: "white",
//             border: "none",
//             padding: "8px 16px",
//             borderRadius: "5px",
//             cursor: "pointer",
//             fontSize: "12px",
//             fontWeight: "600"
//         },
//         showTableBtn: {
//             background: "#28a745",
//             color: "white",
//             border: "none",
//             padding: "10px 20px",
//             borderRadius: "5px",
//             cursor: "pointer",
//             fontSize: "14px",
//             fontWeight: "600",
//             marginTop: "20px",
//             display: "flex",
//             alignItems: "center",
//             gap: "8px",
//             margin: "20px auto 0"
//         },
//         ticketStats: {
//             display: "flex",
//             gap: "15px",
//             marginBottom: "20px",
//             flexWrap: "wrap"
//         },
//         statBadge: {
//             display: "flex",
//             alignItems: "center",
//             gap: "5px",
//             padding: "6px 12px",
//             borderRadius: "20px",
//             fontSize: "13px",
//             fontWeight: "500"
//         },
//         successMessage: {
//             background: "#d4edda",
//             color: "#155724",
//             padding: "15px",
//             borderRadius: "8px",
//             marginBottom: "20px",
//             border: "1px solid #c3e6cb",
//             textAlign: "center",
//             fontWeight: "600",
//             animation: "slideDown 0.5s ease-out"
//         }
//     };

//     const issueTypes = [
//         "Technical Issue",
//         "Billing/Payment",
//         "Account Management",
//         "Delivery Problem",
//         "Food Quality Concern",
//         "Customer Complaint",
//         "Feature Request",
//         "Other"
//     ];

//     const priorities = [
//         { value: "Low", label: "Low - Non-urgent", color: "#28a745" },
//         { value: "Medium", label: "Medium - Normal priority", color: "#ffc107" },
//         { value: "High", label: "High - Business impact", color: "#fd7e14" },
//         { value: "Critical", label: "Critical - System down", color: "#dc3545" }
//     ];

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setTicketData(prev => ({
//             ...prev,
//             [name]: value
//         }));
//     };

//     const handleFileChange = (e) => {
//         const files = Array.from(e.target.files);
//         setTicketData(prev => ({
//             ...prev,
//             attachments: [...prev.attachments, ...files]
//         }));
//     };

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         setIsSubmitting(true);

//         // Simulate API call
//         setTimeout(() => {
//             const newTicket = {
//                 id: "TICKET-" + Math.random().toString(36).substr(2, 9).toUpperCase(),
//                 date: new Date().toLocaleDateString(),
//                 time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
//                 name: ticketData.name,
//                 email: ticketData.email,
//                 phone: ticketData.phone,
//                 issueType: ticketData.issueType,
//                 priority: ticketData.priority,
//                 subject: ticketData.subject,
//                 description: ticketData.description,
//                 status: "Open",
//                 attachments: ticketData.attachments.length
//             };

//             setTickets(prev => [newTicket, ...prev]);
//             setIsSubmitting(false);
//             setShowTable(true);

//             // Reset form
//             setTicketData({
//                 name: "",
//                 email: "",
//                 phone: "",
//                 issueType: "",
//                 priority: "Medium",
//                 subject: "",
//                 description: "",
//                 attachments: []
//             });
//         }, 1000);
//     };

//     const removeAttachment = (index) => {
//         setTicketData(prev => ({
//             ...prev,
//             attachments: prev.attachments.filter((_, i) => i !== index)
//         }));
//     };

//     const getStatusStyle = (status) => {
//         switch (status) {
//             case "Open": return { background: "#cfe2ff", color: "#084298" };
//             case "In Progress": return { background: "#fff3cd", color: "#856404" };
//             case "Resolved": return { background: "#d1e7dd", color: "#0f5132" };
//             case "Closed": return { background: "#f8d7da", color: "#842029" };
//             default: return { background: "#e2e3e5", color: "#383d41" };
//         }
//     };

//     const getPriorityStyle = (priority) => {
//         const priorityObj = priorities.find(p => p.value === priority);
//         return {
//             background: priorityObj?.color + "20",
//             color: priorityObj?.color
//         };
//     };

//     const getStatusStats = () => {
//         const stats = {
//             open: tickets.filter(t => t.status === "Open").length,
//             inProgress: tickets.filter(t => t.status === "In Progress").length,
//             resolved: tickets.filter(t => t.status === "Resolved").length,
//             closed: tickets.filter(t => t.status === "Closed").length,
//             total: tickets.length
//         };
//         return stats;
//     };

//     const handleViewDetails = (ticket) => {
//         alert(`Ticket Details:\n\n` +
//             `ID: ${ticket.id}\n` +
//             `Date: ${ticket.date} ${ticket.time}\n` +
//             `Name: ${ticket.name}\n` +
//             `Email: ${ticket.email}\n` +
//             `Issue: ${ticket.issueType}\n` +
//             `Priority: ${ticket.priority}\n` +
//             `Subject: ${ticket.subject}\n` +
//             `Status: ${ticket.status}\n` +
//             `Attachments: ${ticket.attachments} files`
//         );
//     };

//     const handleCloseTicket = (ticketId) => {
//         setTickets(prev => prev.map(ticket =>
//             ticket.id === ticketId ? { ...ticket, status: "Closed" } : ticket
//         ));
//     };

//     return (
//         <div style={styles.container}>


//             <form onSubmit={handleSubmit} style={styles.form}>
//                 <div style={styles.formRow}>
//                     <div style={styles.formGroup}>
//                         <label htmlFor="name" style={styles.label}>Your Name *</label>
//                         <input
//                             type="text"
//                             id="name"
//                             name="name"
//                             value={ticketData.name}
//                             onChange={handleChange}
//                             required
//                             placeholder="Enter your full name"
//                             style={styles.input}
//                         />
//                     </div>

//                     <div style={styles.formGroup}>
//                         <label htmlFor="email" style={styles.label}>Email Address *</label>
//                         <input
//                             type="email"
//                             id="email"
//                             name="email"
//                             value={ticketData.email}
//                             onChange={handleChange}
//                             required
//                             placeholder="Enter your email"
//                             style={styles.input}
//                         />
//                     </div>
//                 </div>

//                 <div style={styles.formRow}>
//                     <div style={styles.formGroup}>
//                         <label htmlFor="phone" style={styles.label}>Phone Number</label>
//                         <input
//                             type="tel"
//                             id="phone"
//                             name="phone"
//                             value={ticketData.phone}
//                             onChange={handleChange}
//                             placeholder="Enter your phone number"
//                             style={styles.input}
//                         />
//                     </div>

//                     <div style={styles.formGroup}>
//                         <label htmlFor="issueType" style={styles.label}>Issue Type *</label>
//                         <select
//                             id="issueType"
//                             name="issueType"
//                             value={ticketData.issueType}
//                             onChange={handleChange}
//                             required
//                             style={styles.select}
//                         >
//                             <option value="">Select issue type</option>
//                             {issueTypes.map((type, index) => (
//                                 <option key={index} value={type}>{type}</option>
//                             ))}
//                         </select>
//                     </div>
//                 </div>

//                 <div style={styles.formRow}>
//                     <div style={styles.formGroup}>
//                         <label htmlFor="priority" style={styles.label}>Priority Level *</label>
//                         <select
//                             id="priority"
//                             name="priority"
//                             value={ticketData.priority}
//                             onChange={handleChange}
//                             required
//                             style={styles.select}
//                         >
//                             {priorities.map((priority, index) => (
//                                 <option key={index} value={priority.value}>{priority.label}</option>
//                             ))}
//                         </select>
//                     </div>

//                     <div style={styles.formGroup}>
//                         <label htmlFor="subject" style={styles.label}>Subject *</label>
//                         <input
//                             type="text"
//                             id="subject"
//                             name="subject"
//                             value={ticketData.subject}
//                             onChange={handleChange}
//                             required
//                             placeholder="Brief description of your issue"
//                             style={styles.input}
//                         />
//                     </div>
//                 </div>

//                 <div style={styles.formGroup}>
//                     <label htmlFor="description" style={styles.label}>Detailed Description *</label>
//                     <textarea
//                         id="description"
//                         name="description"
//                         value={ticketData.description}
//                         onChange={handleChange}
//                         required
//                         rows="6"
//                         placeholder="Please provide detailed information about your issue..."
//                         style={styles.textarea}
//                     />
//                 </div>

//                 <div style={styles.formGroup}>
//                     <div style={styles.fileUpload}>
//                         <input
//                             type="file"
//                             id="attachments"
//                             multiple
//                             onChange={handleFileChange}
//                             style={styles.fileInput}
//                         />
//                         <label htmlFor="attachments" style={styles.fileLabel}>
//                             📎 Upload Files
//                         </label>
//                         <p style={styles.fileHint}>Maximum 5 files, 10MB each</p>
//                     </div>

//                     {ticketData.attachments.length > 0 && (
//                         <div style={styles.attachmentsList}>
//                             <h4>Attached Files:</h4>
//                             {ticketData.attachments.map((file, index) => (
//                                 <div key={index} style={styles.attachmentItem}>
//                                     <span>{file.name}</span>
//                                     <button
//                                         type="button"
//                                         onClick={() => removeAttachment(index)}
//                                         style={styles.removeButton}
//                                     >
//                                         ×
//                                     </button>
//                                 </div>
//                             ))}
//                         </div>
//                     )}
//                 </div>

//                 <div style={styles.formFooter}>
//                     <button
//                         type="submit"
//                         disabled={isSubmitting}
//                         style={{
//                             ...styles.submitBtn,
//                             ...(isSubmitting ? styles.submitBtnDisabled : {})
//                         }}
//                     >
//                         {isSubmitting ? "Submitting..." : "Submit Ticket"}
//                     </button>
//                     <p style={styles.note}>
//                         * Required fields. Our team typically responds within 2-4 hours.
//                     </p>
//                 </div>
//             </form>

//             {/* Success Message */}
//             {showTable && tickets.length > 0 && (
//                 <div style={styles.successMessage}>
//                     ✅ Ticket submitted successfully! Your new ticket is shown in the table below.
//                 </div>
//             )}

//             {/* Show Table Button (when table is hidden) */}
//             {tickets.length > 0 && !showTable && (
//                 <button
//                     onClick={() => setShowTable(true)}
//                     style={styles.showTableBtn}
//                 >
//                     📋 Show My Tickets ({tickets.length})
//                 </button>
//             )}

//             {/* Tickets Table (shown after submission or when manually toggled) */}
//             {showTable && tickets.length > 0 && (
//                 <div style={styles.tableContainer}>
//                     <div style={styles.tableHeader}>
//                         <h2 style={styles.tableTitle}>My Support Tickets ({tickets.length})</h2>
//                         <button
//                             onClick={() => setShowTable(false)}
//                             style={styles.hideTableBtn}
//                         >
//                             Hide Table
//                         </button>
//                     </div>

//                     {/* Stats Bar */}
//                     <div style={styles.ticketStats}>
//                         <div style={{ ...styles.statBadge, background: "#cfe2ff", color: "#084298" }}>
//                             <div style={{ width: "10px", height: "10px", background: "#084298", borderRadius: "50%" }}></div>
//                             Open: {getStatusStats().open}
//                         </div>
//                         <div style={{ ...styles.statBadge, background: "#fff3cd", color: "#856404" }}>
//                             <div style={{ width: "10px", height: "10px", background: "#856404", borderRadius: "50%" }}></div>
//                             In Progress: {getStatusStats().inProgress}
//                         </div>
//                         <div style={{ ...styles.statBadge, background: "#d1e7dd", color: "#0f5132" }}>
//                             <div style={{ width: "10px", height: "10px", background: "#0f5132", borderRadius: "50%" }}></div>
//                             Resolved: {getStatusStats().resolved}
//                         </div>
//                         <div style={{ ...styles.statBadge, background: "#f8d7da", color: "#842029" }}>
//                             <div style={{ width: "10px", height: "10px", background: "#842029", borderRadius: "50%" }}></div>
//                             Closed: {getStatusStats().closed}
//                         </div>
//                     </div>

//                     <table style={styles.table}>
//                         <thead>
//                             <tr>
//                                 <th style={styles.th}>Ticket ID</th>
//                                 <th style={styles.th}>Date & Time</th>
//                                 <th style={styles.th}>Subject</th>
//                                 <th style={styles.th}>Issue Type</th>
//                                 <th style={styles.th}>Priority</th>
//                                 <th style={styles.th}>Status</th>
//                                 <th style={styles.th}>Actions</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {tickets.map((ticket, index) => (
//                                 <tr key={index}>
//                                     <td style={styles.td}>
//                                         <strong>{ticket.id}</strong>
//                                     </td>
//                                     <td style={styles.td}>
//                                         <div>{ticket.date}</div>
//                                         <div style={{ fontSize: "12px", color: "#666" }}>{ticket.time}</div>
//                                     </td>
//                                     <td style={styles.td}>
//                                         <strong>{ticket.subject}</strong>
//                                         <div style={{ fontSize: "12px", color: "#666", marginTop: "5px" }}>
//                                             By: {ticket.name}
//                                         </div>
//                                     </td>
//                                     <td style={styles.td}>{ticket.issueType}</td>
//                                     <td style={styles.td}>
//                                         <span style={{
//                                             ...styles.priorityBadge,
//                                             ...getPriorityStyle(ticket.priority)
//                                         }}>
//                                             {ticket.priority}
//                                         </span>
//                                     </td>
//                                     <td style={styles.td}>
//                                         <span style={{
//                                             ...styles.statusBadge,
//                                             ...getStatusStyle(ticket.status)
//                                         }}>
//                                             {ticket.status}
//                                         </span>
//                                     </td>
//                                     <td style={styles.td}>
//                                         <button
//                                             onClick={() => handleViewDetails(ticket)}
//                                             style={styles.actionButton}
//                                         >
//                                             View
//                                         </button>
//                                         {ticket.status !== "Closed" && (
//                                             <button
//                                                 onClick={() => handleCloseTicket(ticket.id)}
//                                                 style={{
//                                                     ...styles.actionButton,
//                                                     background: "#dc3545"
//                                                 }}
//                                             >
//                                                 Close
//                                             </button>
//                                         )}
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>
//             )}

//             {/* No Tickets Message */}
//             {tickets.length === 0 && (
//                 <div style={styles.noTickets}>
//                     <p>No tickets raised yet. Submit your first ticket above!</p>
//                 </div>
//             )}

//             <style>
//                 {`
//                 @keyframes fadeIn {
//                     from { opacity: 0; transform: translateY(20px); }
//                     to { opacity: 1; transform: translateY(0); }
//                 }
                
//                 @keyframes slideDown {
//                     from { opacity: 0; transform: translateY(-20px); }
//                     to { opacity: 1; transform: translateY(0); }
//                 }
                
//                 button:hover {
//                     opacity: 0.9;
//                 }
                
//                 @media (max-width: 768px) {
//                     .formRow {
//                         grid-template-columns: 1fr;
//                     }
                    
//                     .ticketStats {
//                         flex-direction: column;
//                         gap: 8px;
//                     }
                    
//                     .statBadge {
//                         width: 100%;
//                         justify-content: center;
//                     }
                    
//                     table {
//                         display: block;
//                         overflow-x: auto;
//                         white-space: nowrap;
//                     }
//                 }
//                 `}
//             </style>
//         </div>
//     );
// };

// export default RaiseTicket;



import React, { useState, useEffect } from "react";

const RaiseTicket = () => {
    const [ticketData, setTicketData] = useState({
        ticketType: "",
        message: "",
        attachmentUrl: ""
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showTable, setShowTable] = useState(false);
    const [tickets, setTickets] = useState([]);
    const [isLoadingTickets, setIsLoadingTickets] = useState(false);
    const [error, setError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");

    const styles = {
        container: {
            padding: "20px",
            maxWidth: "1200px",
            margin: "0 auto",
            marginBottom: "00px",
            paddingTop: window.innerWidth < 500 ? "0px" : " ",
            paddingLeft: window.innerWidth < 500 ? "0px" : " ",
            paddingRight: window.innerWidth < 500 ? "25px" : " ",
        },
        title: {
            color: "#6a0dad",
            marginBottom: "10px",
            textAlign: "center",
            fontSize: "28px",
            fontWeight: "bold"
        },
        subtitle: {
            color: "#666",
            textAlign: "center",
            marginBottom: "30px",
            fontSize: "16px"
        },
        form: {
            background: "#fff",
            borderRadius: "10px",
            padding: "30px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            marginBottom: "40px"
        },
        formRow: {
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "20px",
            marginBottom: "20px"
        },
        formGroup: {
            marginBottom: "20px"
        },
        label: {
            display: "block",
            marginBottom: "8px",
            fontWeight: "bold",
            color: "#333"
        },
        input: {
            width: "100%",
            padding: "12px",
            border: "1px solid #ddd",
            borderRadius: "5px",
            fontSize: "14px"
        },
        select: {
            width: "100%",
            padding: "12px",
            border: "1px solid #ddd",
            borderRadius: "5px",
            fontSize: "14px"
        },
        textarea: {
            width: "100%",
            padding: "12px",
            border: "1px solid #ddd",
            borderRadius: "5px",
            fontSize: "14px",
            resize: "vertical"
        },
        fileUpload: {
            marginTop: "10px"
        },
        fileInput: {
            display: "none"
        },
        fileLabel: {
            display: "inline-block",
            padding: "10px 20px",
            background: "#6a0dad",
            color: "white",
            borderRadius: "5px",
            cursor: "pointer",
            transition: "background 0.3s"
        },
        fileHint: {
            fontSize: "12px",
            color: "#666",
            marginTop: "5px"
        },
        attachmentsList: {
            marginTop: "15px"
        },
        attachmentItem: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "8px",
            background: "#f8f9fa",
            borderRadius: "5px",
            marginBottom: "5px"
        },
        removeButton: {
            background: "#dc3545",
            color: "white",
            border: "none",
            borderRadius: "50%",
            width: "24px",
            height: "24px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "16px"
        },
        formFooter: {
            marginTop: "30px",
            textAlign: "center"
        },
        submitBtn: {
            background: "#6a0dad",
            color: "white",
            border: "none",
            padding: "12px 40px",
            borderRadius: "5px",
            fontSize: "16px",
            cursor: "pointer",
            transition: "background 0.3s"
        },
        submitBtnDisabled: {
            background: "#ccc",
            cursor: "not-allowed"
        },
        note: {
            fontSize: "12px",
            color: "#666",
            marginTop: "10px"
        },
        tableContainer: {
            background: "white",
            borderRadius: "10px",
            padding: "20px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            marginTop: "40px",
            animation: "fadeIn 0.5s ease-in"
        },
        tableHeader: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px"
        },
        tableTitle: {
            color: "#6a0dad",
            margin: 0,
            fontSize: "22px",
            fontWeight: "bold"
        },
        table: {
            width: "100%",
            borderCollapse: "collapse"
        },
        th: {
            padding: "15px",
            textAlign: "left",
            fontWeight: "bold",
            color: "#333",
            borderBottom: "2px solid #dee2e6",
            background: "#f8f9fa"
        },
        td: {
            padding: "15px",
            borderBottom: "1px solid #dee2e6",
            verticalAlign: "top"
        },
        statusBadge: {
            padding: "5px 12px",
            borderRadius: "20px",
            fontSize: "12px",
            fontWeight: "bold",
            display: "inline-block"
        },
        priorityBadge: {
            padding: "4px 10px",
            borderRadius: "4px",
            fontSize: "12px",
            fontWeight: "bold",
            display: "inline-block"
        },
        actionButton: {
            padding: "6px 12px",
            background: "#6a0dad",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontSize: "12px",
            marginRight: "5px"
        },
        noTickets: {
            textAlign: "center",
            padding: "40px",
            color: "#666",
            fontSize: "16px",
            background: "#f8f9fa",
            borderRadius: "10px"
        },
        hideTableBtn: {
            background: "#6a0dad",
            color: "white",
            border: "none",
            padding: "8px 16px",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "12px",
            fontWeight: "600"
        },
        showTableBtn: {
            background: "#28a745",
            color: "white",
            border: "none",
            padding: "10px 20px",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "600",
            marginTop: "20px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            margin: "20px auto 0"
        },
        ticketStats: {
            display: "flex",
            gap: "15px",
            marginBottom: "20px",
            flexWrap: "wrap"
        },
        statBadge: {
            display: "flex",
            alignItems: "center",
            gap: "5px",
            padding: "6px 12px",
            borderRadius: "20px",
            fontSize: "13px",
            fontWeight: "500"
        },
        successMessage: {
            background: "#d4edda",
            color: "#155724",
            padding: "15px",
            borderRadius: "8px",
            marginBottom: "20px",
            border: "1px solid #c3e6cb",
            textAlign: "center",
            fontWeight: "600",
            animation: "slideDown 0.5s ease-out"
        },
        errorMessage: {
            background: "#f8d7da",
            color: "#721c24",
            padding: "15px",
            borderRadius: "8px",
            marginBottom: "20px",
            border: "1px solid #f5c6cb",
            textAlign: "center",
            fontWeight: "600"
        },
        loadingText: {
            textAlign: "center",
            padding: "20px",
            color: "#666",
            fontSize: "16px"
        },
        debugInfo: {
            background: "#f8f9fa",
            padding: "10px",
            borderRadius: "5px",
            marginBottom: "15px",
            fontSize: "12px",
            color: "#666",
            fontFamily: "monospace"
        },
        closeButton: {
            marginLeft: "10px",
            background: "transparent",
            border: "none",
            color: "#721c24",
            cursor: "pointer",
            fontSize: "16px",
            fontWeight: "bold"
        },
        refreshBtn: {
            background: "#28a745",
            color: "white",
            border: "none",
            padding: "8px 16px",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "12px",
            fontWeight: "600"
        },
        adminResponse: {
            maxWidth: "250px",
            wordWrap: "break-word",
            color: "#28a745",
            fontWeight: "500"
        },
        waitingResponse: {
            color: "#666",
            fontStyle: "italic"
        }
    };

    // Ticket types from your API
    const ticketTypes = [
        { value: "PAYOUT_ISSUE", label: "Payout Issue" },
        { value: "SUBSCRIPTION_ISSUE", label: "Subscription Issue" },
        { value: "ORDER_COMPLAINT", label: "Order Complaint" },
        { value: "TECHNICAL_SUPPORT", label: "Technical Support" },
        { value: "OTHER", label: "Other" }
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setTicketData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Check file size (max 5MB)
            if (file.size > 5 * 1024 * 1024) {
                alert("File size should be less than 5MB");
                return;
            }

            const reader = new FileReader();
            reader.onloadend = () => {
                const result = reader.result;
                // Extract base64 part only
                const base64Data = result.split(',')[1];
                setTicketData(prev => ({
                    ...prev,
                    attachmentUrl: base64Data
                }));
            };
            reader.readAsDataURL(file);
        }
    };

    const removeAttachment = () => {
        setTicketData(prev => ({
            ...prev,
            attachmentUrl: ""
        }));
    };

    // Fetch tickets for the vendor
    const fetchVendorTickets = async () => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!vendorId || !token) {
            console.error("Vendor ID or Token not found");
            setError("Authentication required. Please login.");
            return;
        }

        try {
            setIsLoadingTickets(true);
            const response = await fetch(
                `https://backend.maamaas.com/food/api/vendor-tickets/vendor/${vendorId}`,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Accept": "application/json"
                    }
                }
            );

            //console.log("GET Tickets - Status:", response.status);
            
            if (response.ok) {
                const data = await response.json();
                //console.log("GET Tickets - Data:", data);
                
                if (Array.isArray(data)) {
                    // Sort by createdAt (newest first)
                    const sortedTickets = data.sort((a, b) => 
                        new Date(b.createdAt) - new Date(a.createdAt)
                    );
                    setTickets(sortedTickets);
                } else {
                    console.error("Unexpected response format:", data);
                    setTickets([]);
                }
            } else {
                console.error("GET Tickets failed:", response.status);
                setError(`Failed to load tickets: ${response.status}`);
            }
        } catch (error) {
            console.error("Error fetching tickets:", error);
            setError("Network error while loading tickets");
        } finally {
            setIsLoadingTickets(false);
        }
    };

    // Load tickets when component mounts
    useEffect(() => {
        fetchVendorTickets();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSuccessMessage("");
        
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!vendorId || !token) {
            alert("Vendor ID or Token not found in localStorage. Please login again.");
            return;
        }

        if (!ticketData.ticketType || !ticketData.message) {
            alert("Please select a ticket type and enter a message");
            return;
        }

        // Prepare payload according to your API
        const payload = {
            vendorId: Number(vendorId),
            ticketType: ticketData.ticketType,
            message: ticketData.message,
            attachmentUrl: ticketData.attachmentUrl || null
        };

        //console.log("Submitting payload:", payload);

        setIsSubmitting(true);

        try {
            const response = await fetch(
                "https://backend.maamaas.com/food/api/vendor-tickets/create",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`
                    },
                    body: JSON.stringify(payload)
                }
            );

            //console.log("POST Response - Status:", response.status);
            
            const result = await response.json();
            //console.log("POST Response - Data:", result);

            if (response.ok) {
                setSuccessMessage("Ticket submitted successfully!");
                // Reset form
                setTicketData({
                    ticketType: "",
                    message: "",
                    attachmentUrl: ""
                });
                // Refresh tickets list
                await fetchVendorTickets();
                setShowTable(true);
            } else {
                // Show detailed error
                const errorMsg = result.message || 
                                result.error || 
                                `API Error: ${response.status} ${response.statusText}`;
                setError(errorMsg);
            }
        } catch (error) {
            console.error("Error submitting ticket:", error);
            setError("Network error: " + error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    const getStatusStyle = (status) => {
        switch (status) {
            case "OPEN": return { background: "#cfe2ff", color: "#084298" };
            case "IN_PROGRESS": return { background: "#fff3cd", color: "#856404" };
            case "RESOLVED": return { background: "#d1e7dd", color: "#0f5132" };
            case "REJECTED": return { background: "#f8d7da", color: "#842029" };
            default: return { background: "#e2e3e5", color: "#383d41" };
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            }) + " " + date.toLocaleTimeString([], { 
                hour: '2-digit', 
                minute: '2-digit' 
            });
        } catch (e) {
            return "Invalid date";
        }
    };

    const handleViewDetails = (ticket) => {
        alert(`Ticket Details:\n\n` +
            `ID: ${ticket.id || "N/A"}\n` +
            `Date: ${formatDate(ticket.createdAt)}\n` +
            `Type: ${ticket.ticketType}\n` +
            `Status: ${ticket.status}\n` +
            `Message: ${ticket.message}\n` +
            `Admin Response: ${ticket.adminResponse || "No response yet"}\n` +
            `Resolved At: ${ticket.resolvedAt ? formatDate(ticket.resolvedAt) : "Not resolved"}`
        );
    };

    const getStatusStats = () => {
        const stats = {
            open: tickets.filter(t => t.status === "OPEN").length,
            inProgress: tickets.filter(t => t.status === "IN_PROGRESS").length,
            resolved: tickets.filter(t => t.status === "RESOLVED").length,
            rejected: tickets.filter(t => t.status === "REJECTED").length,
            total: tickets.length
        };
        return stats;
    };

    return (
        <div style={styles.container}>
            <h1 style={styles.title}>Raise a Support Ticket</h1>
            <p style={styles.subtitle}>Our team will respond to your query as soon as possible</p>

            {/* Success Message */}
            {successMessage && (
                <div style={styles.successMessage}>
                    ✅ {successMessage}
                </div>
            )}

            {/* Error Message */}
            {error && (
                <div style={styles.errorMessage}>
                    ❌ {error}
                    <button 
                        onClick={() => setError("")}
                        style={styles.closeButton}
                    >
                        ×
                    </button>
                </div>
            )}

            <form onSubmit={handleSubmit} style={styles.form}>
               

                <div style={styles.formRow}>
                    <div style={styles.formGroup}>
                        <label htmlFor="ticketType" style={styles.label}>Ticket Type *</label>
                        <select
                            id="ticketType"
                            name="ticketType"
                            value={ticketData.ticketType}
                            onChange={handleChange}
                            required
                            style={styles.select}
                        >
                            <option value="">Select ticket type</option>
                            {ticketTypes.map((type, index) => (
                                <option key={index} value={type.value}>{type.label}</option>
                            ))}
                        </select>
                    </div>

                    <div style={styles.formGroup}>
                        <label style={styles.label}>Attachment (Optional)</label>
                        <div style={styles.fileUpload}>
                            <input
                                type="file"
                                id="attachment"
                                accept="image/*"
                                onChange={handleImageChange}
                                style={styles.fileInput}
                            />
                            <label htmlFor="attachment" style={styles.fileLabel}>
                                📎 Upload Image
                            </label>
                            <p style={styles.fileHint}>Max 5MB. JPG, PNG formats only.</p>
                        </div>

                        {ticketData.attachmentUrl && (
                            <div style={styles.attachmentsList}>
                                <div style={styles.attachmentItem}>
                                    <span>Image attached ✓</span>
                                    <button
                                        type="button"
                                        onClick={removeAttachment}
                                        style={styles.removeButton}
                                    >
                                        ×
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div style={styles.formGroup}>
                    <label htmlFor="message" style={styles.label}>Message / Description *</label>
                    <textarea
                        id="message"
                        name="message"
                        value={ticketData.message}
                        onChange={handleChange}
                        required
                        rows="6"
                        placeholder="Please describe your issue in detail. Be as specific as possible to help us resolve it faster..."
                        style={styles.textarea}
                    />
                </div>

                <div style={styles.formFooter}>
                    <button
                        type="submit"
                        disabled={isSubmitting}
                        style={{
                            ...styles.submitBtn,
                            ...(isSubmitting ? styles.submitBtnDisabled : {})
                        }}
                    >
                        {isSubmitting ? "Submitting..." : "Submit Ticket"}
                    </button>
                    <p style={styles.note}>
                        * Required fields. Our support team typically responds within few hours.
                    </p>
                </div>
            </form>

            {/* Tickets Table */}
            <div style={styles.tableContainer}>
                <div style={styles.tableHeader}>
                    <h2 style={styles.tableTitle}>My Support Tickets ({tickets.length})</h2>
                    <button
                        onClick={fetchVendorTickets}
                        style={styles.refreshBtn}
                    >
                        ↻ Refresh
                    </button>
                </div>

                {/* Stats Bar */}
                {tickets.length > 0 && (
                    <div style={styles.ticketStats}>
                        <div style={{ ...styles.statBadge, background: "#cfe2ff", color: "#084298" }}>
                            <div style={{ width: "10px", height: "10px", background: "#084298", borderRadius: "50%" }}></div>
                            Open: {getStatusStats().open}
                        </div>
                        <div style={{ ...styles.statBadge, background: "#fff3cd", color: "#856404" }}>
                            <div style={{ width: "10px", height: "10px", background: "#856404", borderRadius: "50%" }}></div>
                            In Progress: {getStatusStats().inProgress}
                        </div>
                        <div style={{ ...styles.statBadge, background: "#d1e7dd", color: "#0f5132" }}>
                            <div style={{ width: "10px", height: "10px", background: "#0f5132", borderRadius: "50%" }}></div>
                            Resolved: {getStatusStats().resolved}
                        </div>
                        <div style={{ ...styles.statBadge, background: "#f8d7da", color: "#842029" }}>
                            <div style={{ width: "10px", height: "10px", background: "#842029", borderRadius: "50%" }}></div>
                            Rejected: {getStatusStats().rejected}
                        </div>
                    </div>
                )}

                {isLoadingTickets ? (
                    <div style={styles.loadingText}>Loading tickets...</div>
                ) : tickets.length > 0 ? (
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.th}>Ticket ID</th>
                                <th style={styles.th}>Date & Time</th>
                                <th style={styles.th}>Type</th>
                                <th style={styles.th}>Message</th>
                                <th style={styles.th}>Status</th>
                                <th style={styles.th}>Admin Response</th>
                                <th style={styles.th}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tickets.map((ticket) => (
                                <tr key={ticket.id}>
                                    <td style={styles.td}>
                                        <strong>#{ticket.id}</strong>
                                    </td>
                                    <td style={styles.td}>
                                        {formatDate(ticket.createdAt)}
                                    </td>
                                    <td style={styles.td}>
                                        {ticket.ticketType.replace(/_/g, ' ')}
                                    </td>
                                    <td style={styles.td}>
                                        <div style={{ maxWidth: "250px", wordWrap: "break-word" }}>
                                            {ticket.message}
                                        </div>
                                    </td>
                                    <td style={styles.td}>
                                        <span style={{
                                            ...styles.statusBadge,
                                            ...getStatusStyle(ticket.status)
                                        }}>
                                            {ticket.status}
                                        </span>
                                    </td>
                                    <td style={styles.td}>
                                        {ticket.adminResponse ? (
                                            <div style={styles.adminResponse}>
                                                ✓ {ticket.adminResponse}
                                            </div>
                                        ) : (
                                            <span style={styles.waitingResponse}>
                                                Waiting for response
                                            </span>
                                        )}
                                    </td>
                                    <td style={styles.td}>
                                        <button
                                            onClick={() => handleViewDetails(ticket)}
                                            style={styles.actionButton}
                                        >
                                            View Details
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <div style={styles.noTickets}>
                        <p>No tickets found. Submit your first ticket above!</p>
                    </div>
                )}
            </div>

            <style>
                {`
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                
                @keyframes slideDown {
                    from { opacity: 0; transform: translateY(-20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                
                button:hover {
                    opacity: 0.9;
                    transform: translateY(-1px);
                    transition: all 0.2s ease;
                }
                
                button:active {
                    transform: translateY(0);
                }
                
                input:focus, select:focus, textarea:focus {
                    outline: none;
                    border-color: #6a0dad;
                    box-shadow: 0 0 0 2px rgba(106, 13, 173, 0.2);
                }
                
                .fileLabel:hover {
                    background: #5a0c9d;
                }
                
                .actionButton:hover {
                    background: #5a0c9d;
                }
                
                .refreshBtn:hover {
                    background: #218838;
                }
                
                @media (max-width: 768px) {
                    .formRow {
                        grid-template-columns: 1fr;
                    }
                    
                    .ticketStats {
                        flex-direction: column;
                        gap: 8px;
                    }
                    
                    .statBadge {
                        width: 100%;
                        justify-content: center;
                    }
                    
                    table {
                        display: block;
                        overflow-x: auto;
                        white-space: nowrap;
                    }
                    
                    th, td {
                        padding: 10px 8px;
                        font-size: 14px;
                    }
                    
                    .tableHeader {
                        flex-direction: column;
                        gap: 10px;
                        align-items: flex-start;
                    }
                    
                    .tableTitle {
                        font-size: 18px;
                    }
                }
                
                @media (max-width: 480px) {
                    .container {
                        padding: 10px;
                    }
                    
                    .form {
                        padding: 20px;
                    }
                    
                    .title {
                        font-size: 24px;
                    }
                    
                    .subtitle {
                        font-size: 14px;
                    }
                }
                
                /* Scrollbar styling */
                textarea::-webkit-scrollbar {
                    width: 6px;
                }
                
                textarea::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 3px;
                }
                
                textarea::-webkit-scrollbar-thumb {
                    background: #c1c1c1;
                    border-radius: 3px;
                }
                
                textarea::-webkit-scrollbar-thumb:hover {
                    background: #a1a1a1;
                }
                `}
            </style>
        </div>
    );
};

export default RaiseTicket;